import { AbstractControl, UntypedFormArray, ValidatorFn } from '@angular/forms';
import { AppConstans } from '../appConstants';
import { InfoFromCisloUjDto } from '../dto/InfoFromCisloUjDto';
import { UjParseUtils } from '../Utils/uj.parse.utils';

/**
 * Validátor slučování oddílů. Kontroluje vlastnosti získané z UJ.
 * @param ujParseUtils
 */
export function SlouceniOddiluDleUjValidator(ujParseUtils: UjParseUtils): ValidatorFn {
  
  /**
   * Vstupní array zbaví duplicitních hodnot a pokud je výsledný počet 1, byly všechny hodnoty stejné.
   * @param array
   */
  var _validate = function (array: any[]): boolean {
    let withoutDuplicities: string[] = array.filter((value, index) => array.indexOf(value) == index);
    return withoutDuplicities.length == 1;
  }


  return (control: AbstractControl): { [key: string]: any | null } => {
    let errors = {};
    let oddily: AbstractControl[] = (control as UntypedFormArray)?.controls;

    //vlastní porovnání má smysl pouze, pokud je více oddílů (tj. min 2)
    if (oddily != void 0 && oddily.length > 1) {
      let cujs = oddily.map(odd => odd.get('evCisloUj')?.value);
      let ujInfos: InfoFromCisloUjDto[] = [];
      cujs.forEach(cuj => ujInfos.push(ujParseUtils.parseUj(cuj)));

      if (!_validate(ujInfos.map(x => x.oblastProvenience))) {
        errors['ploError'] = 'Slučovat lze pouze oddíly stejné oblasti provenience.';
      }

      if (!_validate(ujInfos.map(x => x.druhDreviny))) {
        errors['drevinaError'] = 'Slučovat lze pouze oddíly stejné dřeviny.';
      }

      let kategorieRm = ujInfos.map(x => x.repMaterialKategorie);
      if (!_validate(kategorieRm)) {
        errors['kategorieRmError'] = 'Slučovat lze pouze oddíly stejné kategorie reprodukčního materiálu.';
      }

      if (kategorieRm.indexOf(AppConstans.kategorieRm?.testovany) != -1) {
        errors['testovanyRmError'] = 'Oddíly testovaného reprodukčního materiálu se neslučují.';
      }

      if (kategorieRm.indexOf(AppConstans.kategorieRm?.kvalifikovany) != -1) {
        errors['kvalifikovanyRmError'] = 'Oddíly kvalifikovaného reprodukčního materiálu se neslučují.';
      }

      let selectovanePorosty2A = ujInfos.filter(x => x.repMaterialKategorie == AppConstans.kategorieRm?.selektovany && x.typZdrojeRepMaterialu == AppConstans.typZdrojeRm?.porost2A)
      if (selectovanePorosty2A.length > 0) {
        errors['selektovanyRmError'] = 'Oddíly selektovaného reprodukčního materiálu fenotypové klasifikace \'A\' se neslučují.';
      }

      if (!_validate(ujInfos.map(x => x.genovaZakladna))) {
        errors['genovaZakladnaError'] = 'Slučovat lze pouze oddíly ze stejné genové základny.'
      }

      if (!_validate(ujInfos.map(x => x.vyskovePasmo))) {
        errors['vyskovePasmoError'] = 'Slučovat lze pouze oddíly ze stejného výškového pásma.';
      }
    }

    return Object.keys(errors).length != 0 ? errors : null;
  }
}
